import { useState, useEffect } from "react";
import { fetchLabels } from "../../../../utils/api";

function useMarkerLabel(projectId) {
    // null = 未ロード、[] = ロード済みだがラベルなし、配列 = ロード済み
    const [labels, setLabels] = useState(null);
    const [loading, setLoading] = useState(!!projectId);

    useEffect(() => {
        if (!projectId) {
            setLabels(null);
            setLoading(false);
            return;
        }

        let cancelled = false;
        setLoading(true);

        fetchLabels(projectId)
            .then((data) => {
                if (!cancelled) setLabels(data);
            })
            .catch((err) => {
                if (!cancelled) {
                    console.error("ラベル取得失敗:", err);
                    setLabels([]);
                }
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });

        // StrictMode の二重実行やprojectId変更時に前のリクエスト結果を捨てる
        return () => { cancelled = true; };
    }, [projectId]);

    return {
        data: { labels },
        loading,
    };
}

export default useMarkerLabel;
